import React, { useEffect } from "react";
import styles from "./legal_info.module.css";
import { useLocation } from "react-router-dom";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { SHOP_NAME } from "../../utils/constants";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSettings } from "../../services/selectors";
import { ROUTES_CONST } from "../../utils/constants";


const Cookie = () => {

  const settings = useSelector(getSettings);
  const location = useLocation();
  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  return (
    <main className="main">
      <h1 className="title title__left">
        {title}
      </h1>
      <p className={styles.text}>
        При работе сайта&ensp;
        <Link to='/' className={styles.link}>
          {settings.shop_name || SHOP_NAME}
        </Link>
        &ensp;используются файлы cookie,
        которые помогают предоставлять Вам возможность удобного пользования
        сайтом, также благодаря этим файлам мы работаем над улучшением сайта
        в целом. Продолжая просматривать сайт, Вы соглашаетесь на использование
        нами файлов cookie.
      </p>
      <p className={styles.text}>
        Файлы cookie – это небольшие файлы, состоящие из букв и цифр, которые
        мы сохраняем в Вашем браузере или на жестком диске Вашего компьютера в
        случае согласия с Вашей стороны. В файлах cookie содержится информация,
        которая передается на жесткий диск Вашего компьютера. Мы используем
        следующие файлы cookie: Строго необходимые файлы cookie. Это файлы cookie,
        наличие которых обязательно для правильного функционирования нашего Сайта.
      </p>
      <p className={styles.text}>
        В их состав входят, например, файлы cookie, позволяющие выполнить вход в
        безопасные области Сайта. Аналитические файлы cookie / файлы cookie для
        расчёта производительности сайта. С помощью таких файлов появляется возможность
        распознать и подсчитать количество посетителей нашего Сайта, а также сделать
        анализ различных вариантов пользования Сайтом посетителями. Благодаря наличию
        таких файлов cookie мы узнаем о том, как нам улучшить функционирование нашего Сайта.
      </p>
      <p className={styles.text}>
        Файлы cookie функциональных возможностей. Данные файлы используются для того,
        чтобы узнавать Вас в момент возвращения на наш Сайт. Это позволяет делать
        содержание сайта персонализированным специально для Вас, например, приветствовать
        Вас по имени и запоминать Ваши предпочтения.
      </p>
      <p className={styles.text}>
        Целевые файлы cookie. Эти файлы cookie записывают Ваши посещения нашего Сайта,
        например, посещаемые страницы и ссылки, которыми Вы пользовались. Мы используем
        эту информацию для того, чтобы наш сайт и реклама, отображаемая на нем, были
        более подходящими для Вас лично и связанными с Вашими интересами. Мы также вправе
        делиться такой информацией с третьими лицами в этих целях.
      </p>
      <p className={styles.text}>
        Следует обратить внимание на то, что третьим сторонам также разрешено
        использовать файлы cookie, но с нашей стороны мы не осуществляем контроль в
        отношении данного процесса. (Эти файлы, скорее, являются Аналитическими файлами
        cookie / файлами cookie для расчёта производительности сайта). Если Вы против
        использования файлов cookie с нашей стороны в соответствии с тем, как это было
        обозначено выше, или в случае изменения Вашего мнения после того, как Вы дадите
        согласие на использование нами файлов cookie, Вы вправе удалить и заблокировать
        файлы cookie на этом сайте через Ваш браузер. Если Вы используете настройки браузера
        таким образом, что выставляется блокировка всех файлов cookie (включая основные
        категории файлов cookie), возможно, что некоторые компоненты нашего сайта не будут
        работать.
      </p>
    </main>
  )
}

export default Cookie;
